// collects the listener unsubscribes for one effect run so its cleanup can
// close them all:
//
//   useEffect(() => {
//     const session = createListenerSession();
//     getSomethingFromDb({ ..., 'handleListener': session.track });
//     return () => session.close();
//   }, [...]);
//
// a listener registered after close() — some helpers attach theirs only after
// an awaited call — is shut down immediately instead of leaking. async work
// checks session.active before setting state so late results from a
// torn-down run are dropped. RTDB helpers hand back a query instead of an
// unsubscribe function, so wrap those: session.track(() => off(query)).
export function createListenerSession() {
  const unsubs = [];
  const session = {
    active: true,
    track(unsub) {
      if (session.active) unsubs.push(unsub);
      else unsub();
    },
    close() {
      session.active = false;
      unsubs.forEach(unsub => unsub());
    }
  };
  return session;
}
